<template>
    <Menu as="div" class="relative inline-block text-left">
        <div>
            <MenuButton
                class="inline-flex justify-center items-center w-full font-medium focus:outline-none text-nutreance-green hover:text-nutreance-green-lighter text-left"
            >
                <span>
                    {{ address.name }}
                    <span v-if="blacklisted">(Blacklisted)</span>
                </span>
                <ChevronDownIcon class="ml-1 h-5 w-5" aria-hidden="true" />
            </MenuButton>
        </div>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <MenuItems
                class="z-20 origin-top-left absolute left-0 mt-1 w-64 -ml-16 rounded-md shadow-lg bg-white text-gray-800 divide-y divide-gray-100 focus:outline-none"
            >
                <div class="px-4 py-3 text-sm">
                    <p class="font-semibold">
                        {{ address.name }}
                        <span v-if="blacklisted">(Blacklisted)</span>
                    </p>
                    <p>
                        {{ address.line1 }}
                    </p>
                    <p v-if="address.line2">
                        {{ address.line2 }}
                    </p>
                    <p v-if="address.state">
                        {{ address.city }}, {{ address.state }}
                        {{ address.postal_code }}
                    </p>
                    <p v-else>{{ address.city }} {{ address.postal_code }}</p>
                    <p>
                        {{ address.country.name }}
                    </p>
                </div>
                <div
                    v-if="address.email || address.phone"
                    class="px-4 py-3 text-sm space-y-2"
                >
                    <span class="flex" v-if="address.email">
                        <span class="sr-only">Email:</span>
                        <MailIcon
                            class="mr-2 h-4 w-4 shrink-0"
                            aria-hidden="true"
                        />
                        <span class="break-all">
                            {{ address.email }}
                        </span>
                    </span>

                    <span class="flex" v-if="address.phone">
                        <span class="sr-only">Phone:</span>
                        <PhoneIcon
                            class="mr-2 h-4 w-4 shrink-0"
                            aria-hidden="true"
                        />
                        <span class="break-all">
                            {{ address.phone }}
                        </span>
                    </span>
                </div>
            </MenuItems>
        </transition>
    </Menu>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Menu, MenuButton, MenuItems } from "@headlessui/vue";
import { ChevronDownIcon, MailIcon, PhoneIcon } from "@heroicons/vue/solid";

const props = defineProps<{
    address?: any;
    canSeeIfAnyAddressIsBlacklisted?: string;
}>();

const blacklisted = computed(
    () => props.canSeeIfAnyAddressIsBlacklisted && props.address.blacklisted,
);
</script>
